<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { suppliertypeService } from "../../../../../services/settingservice/configurationservice/suppliertype.service";
// import { settingService } from "../../../../services/settingservice/setting.service";
import List from "../../../../../components/list";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "supplier Type List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      supplierTypeList: {},

      fetchingStats: false,
      title: "supplier Type List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      suppliertypeService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.supplierTypeList = response;
        });
    },

    deleted: function(id) {
      suppliertypeService.remove(id)
        .then(response => {
        
          // this.supplierData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-supplier-type-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-supplier-type-add'}" :title="$t('setting.configuration.supplier-type.text')" />
    <List v-bind:dataList="supplierTypeList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[`name: ${$t('setting.configuration.supplier-type.name')}`, 
            `name_en: ${$t('setting.configuration.supplier-type.name-en')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-supplier-type-edit'}"
          v-bind:filter="{
            search: ['supplier_types.name', 'supplier_types.name_en'],
            dropdown: []

          }"
          
    />      
  </Layout>
</template>